<template>
  <div class="setting-helper">
    <div class="heading">
      <span class="data-title">{{ $t('settingHelper.studyParameters') }}</span>
    </div>
    <div class="site-container">
      <span class="site-title">{{ $t('actualSites', currentSites.length) }}</span>
      <div v-for="site in currentSites" :key="site.id" class="current-site">
        <div class="name-container">
          <div class="site-icon"></div>
          <div class="site-name">{{ site.name }}</div>
        </div>
        <div class="site-address">{{ site.address }}</div>
      </div>
      <p v-if="sites.length === 0" class="standalone">0 {{ $t('actualSites', 0) }}</p>

      <span class="site-title">{{ $t('futureSite', formattedSites.length) }}</span>
      <SiteBox v-for="(site, idx) in formattedSites" :key="idx" :idx="idx" :data="site" :class="{ active: active === idx }" :action="() => selectSite(idx)" />
      <p v-if="sites.length === 0" class="standalone">0 {{ $t('futureSite', 0) }}</p>
    </div>
  </div>
</template>

<script>
import SiteBox from './SiteBox';
import assetProvider from '@/pure/assetProvider';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  components: {
    SiteBox,
  },

  props: ['sites', 'active'],

  computed: {
    currentSites() {
      return this.sites
        .filter(item => item.type === 'Actual')
        .map((item, key) => {
          if (item.lat_lng) {
            item.latLng = item.lat_lng;
          }
          item.poi = assetProvider[`poi${key + 1}`];
          if (!item.image) {
            item.image = item.picture_path || assetProvider.placeHolderSite;
          }
          return item;
        });
    },

    formattedSites() {
      return this.sites
        .filter(item => item.type === 'Target')
        .map((item, key) => {
          if (item.lat_lng) {
            item.latLng = item.lat_lng;
          }
          item.poi = assetProvider[`poi${key + 1}`];
          if (!item.image) {
            item.image = item.picture_path || assetProvider.placeHolderSite;
          }
          return item;
        });
    },
  },

  created() {
    this.$socket = useSignalR();
  },

  methods: {
    selectSite(idx) {
      if (idx !== this.active) {
        this.$store.dispatch('updateIndex', idx);
        if (!this.isDesktop || this.$route.name === 'Controller') {
          this.$socket.invoke('action', { action: 'upadteIndex', parameters: idx });
        }
      } else {
        this.$store.dispatch('updateIndex', -1);
        if (!this.isDesktop || this.$route.name === 'Controller') {
          this.$socket.invoke('action', { action: 'upadteIndex', parameters: -1 });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.setting-helper {
  position: fixed;
  top: 114px;
  right: 4px;
  z-index: 2;
  background-color: colors.$white-color;
  width: 272px;
  max-height: 514px;
  box-shadow: 0 0 4px rgba(colors.$black-color, 0.25);
  overflow-x: hidden;
  overflow-y: auto;
  .heading {
    background-color: colors.$beige-color;
    padding-left: 20px;
    height: 48px;
    display: flex;

    .data-title {
      font-size: 13.44px;
      color: colors.$dark-grey-color;
    }
  }
  .site-container {
    .site-title {
      height: 30px;
      align-items: center;
      display: flex;
      padding-left: 12px;
      font-size: 12px;
      font-weight: 700;
    }
    p.standalone {
      text-transform: lowercase;
    }
    .current-site {
      width: 100%;
      border-top: solid 1px colors.$grey-color;
      border-bottom: solid 1px colors.$grey-color;
      padding: 8px 12px;
      box-sizing: border-box;
      margin: -1px 0 0 0;

      .name-container {
        display: flex;
        align-items: center;

        .site-icon {
          $raidus: 12px;
          width: $raidus;
          height: $raidus;
          background: colors.$main-color;
          border-radius: $raidus;
          margin: 0 4px 0 0;
        }
        .site-name {
          font-weight: bold;
          font-size: 12px;
        }
      }
      .site-address {
        margin: 2px 0 0 0;
        font-size: 10px;
      }
    }
    .site-box {
      height: 70px;
      box-sizing: border-box;
      border: 1px solid colors.$grey-color;
      border-left-color: rgba(colors.$grey-color, 0);
      border-right-color: rgba(colors.$grey-color, 0);
      transition:
        box-shadow 0.3s ease,
        background-color 0.3s ease,
        border-color 0.3s ease;
      box-shadow: 0 0 0px rgba(colors.$black-color, 0.15);
      position: relative;
      & + .site-box {
        margin-top: -1px;
      }
      &:hover {
        z-index: 2;
        box-shadow: 0 0 4px rgba(colors.$black-color, 0.15);
        background-color: colors.$light-grey-color;
        border-color: colors.$red-color;
      }
      &.active {
        z-index: 1;
        box-shadow: 0 0 4px rgba(colors.$black-color, 0.15);
        background-color: colors.$light-grey-color;
        border-color: colors.$concrete-color;
      }
    }
  }
}
</style>
